module.exports = __webpack_public_path__ + "img/brand-27.8e5e27ab.png";